import { Search, X, Trash2 } from "lucide-react";
import { statusFilters } from "./userConstants";

const UsersToolbar = ({
  searchQuery, onSearchChange, statusFilter, onStatusChange,
  selectedCount, onBulkDelete, onClearSelection, stats = {},
}) => (
  <div className="sz-card p-4">
    <div className="flex items-center gap-3 flex-wrap">
      {/* Search */}
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A8AEBC]" />
        <input
          type="text"
          placeholder="Search name, email, phone or user #…"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="sz-input pl-9 pr-9"
        />
        {searchQuery && (
          <button
            onClick={() => onSearchChange("")}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-[#A8AEBC] hover:text-[#0C1120]"
            aria-label="Clear search"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>

      {/* Status filter pills */}
      <div className="flex gap-1.5 overflow-x-auto szscroll">
        {statusFilters.map((f) => {
          const isActive = statusFilter === f.key;
          const count = stats[f.countField];
          return (
            <button
              key={f.key}
              onClick={() => onStatusChange(f.key)}
              className={`sz-pill ${isActive ? "sz-active" : ""}`}
            >
              {f.label}
              {count != null && <span className="sz-pill-count">{count}</span>}
            </button>
          );
        })}
      </div>
    </div>

    {/* Bulk action bar */}
    {selectedCount > 0 && (
      <div className="flex items-center justify-between gap-3 mt-3 px-3.5 py-2.5 rounded-[11px] bg-[#FEF2F2] border border-[#FECACA]">
        <span className="text-[12.5px] font-semibold text-[#B91C1C]">{selectedCount} selected</span>
        <div className="flex gap-2">
          <button
            onClick={onClearSelection}
            className="px-3 py-1.5 rounded-[9px] border border-[#E0E3EB] bg-white text-xs font-semibold text-[#2B3142] hover:border-[#A8AEBC]"
          >
            Clear
          </button>
          <button
            onClick={onBulkDelete}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-[9px] bg-[#DC2626] hover:bg-[#B91C1C] text-white text-xs font-semibold"
          >
            <Trash2 className="w-3.5 h-3.5" />Delete selected
          </button>
        </div>
      </div>
    )}
  </div>
);

export default UsersToolbar;
